import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { f } from "./index-LyFokDcn.mjs";
import { m } from "./tss-DN0acMKN.mjs";
import { M as n, d as t } from "./constants-CnFYFetN.mjs";
import { L as y } from "./layout-box-DFBM-kSI.mjs";
import { D as g } from "./divider-Dq5lrAFK.mjs";
import { I as p } from "./icon-v2-DGtVEk7e.mjs";
import { L as D } from "./link-unstyled-CvXR-8s6.mjs";
const h = () => f.ifFeature(
  "encore",
  /* @__PURE__ */ s.jsx(y, { paddingY: "12px", children: /* @__PURE__ */ s.jsx(g, { color: "neutral-extra-weak", noGap: !0 }) }),
  /* @__PURE__ */ s.jsx(g, { light: !0 })
), S = m()(({ borderRadiuses: o, constructs: i, mode: r, palette: e, spacing: a, typography: c }, { active: l }) => {
  const d = l ? e.primary.main : e.gray[800];
  return f.ifFeature(
    "encore",
    {
      root: {
        alignItems: "center",
        backgroundColor: l ? e.gray[100] : "transparent",
        borderRadius: "8px",
        color: r === n.Dye ? t.main : d,
        display: "flex",
        fill: r === n.Dye ? t.main : d,
        fontSize: c.small.fontSize,
        fontWeight: l ? c.fontWeightHeavy : "",
        gap: a(1.5),
        lineHeight: c.small.lineHeight,
        padding: `${a(1)} ${a(1.5)}`,
        textDecoration: "none",
        "&:hover": {
          backgroundColor: e.gray[100],
          color: r === n.Dye ? t.main : e.primary.main,
          fill: r === n.Dye ? t.main : e.primary.main,
          textDecoration: "none"
        },
        "&:focus-visible": {
          borderRadius: o[200],
          boxShadow: `0 0 0 2px color-mix(in srgb, ${i.surface.primary.medium} 80%, transparent)`,
          color: e.primary.main,
          fill: e.primary.main
        }
      },
      disabled: {
        backgroundColor: "transparent",
        color: r === n.Dye ? t.lighter : e.gray[600],
        cursor: "default",
        fill: r === n.Dye ? t.lighter : e.gray[600],
        pointerEvents: "none"
      }
    },
    {
      root: {
        alignItems: "center",
        backgroundColor: l ? e.gray[100] : "transparent",
        border: "none",
        borderRadius: "2px",
        boxSizing: "border-box",
        color: r === n.Dye ? t.main : d,
        display: "flex",
        fill: r === n.Dye ? t.main : d,
        fontWeight: l ? c.fontWeightHeavy : "",
        gap: a(1),
        marginLeft: "0",
        overflowWrap: "anywhere",
        padding: "9px 10px",
        textDecoration: "none",
        textIndent: "0",
        "&:hover": {
          backgroundColor: e.gray[100],
          borderRadius: "4px",
          color: r === n.Dye ? t.main : e.primary.main,
          fill: r === n.Dye ? t.main : e.primary.main,
          textDecoration: "none"
        }
      },
      disabled: {
        alignItems: "center",
        backgroundColor: "transparent",
        border: "none",
        borderRadius: "2px",
        boxSizing: "border-box",
        color: r === n.Dye ? t.lighter : e.gray[500],
        cursor: "default",
        display: "flex",
        fill: r === n.Dye ? t.lighter : e.gray[500],
        gap: a(1),
        marginLeft: "0",
        padding: "9px 10px",
        pointerEvents: "none",
        textDecoration: "none",
        textIndent: "0"
      }
    }
  );
});
function v(o) {
  const { active: i, activeIcon: r, children: e, disabled: a, icon: c, ...l } = o, { classes: d, cx: b } = S({ active: i }), x = i && r ? r : c;
  return /* @__PURE__ */ s.jsxs(
    D,
    {
      ...l,
      className: b(d.root, { [d.disabled]: a }),
      tabIndex: a ? -1 : void 0,
      children: [
        f.ifFeature(
          "encore",
          typeof x == "string" ? /* @__PURE__ */ s.jsx(p, { name: x, size: 16 }) : null,
          x
        ),
        e
      ]
    }
  );
}
const k = m()(({ mode: o, typography: i }) => ({
  root: {
    color: o === n.Dye ? t.main : void 0,
    fontSize: i.biggie.fontSize,
    fontWeight: i.fontWeightSemibold,
    lineHeight: i.biggie.lineHeight,
    padding: "9px 10px"
  }
}));
function $({ children: o }) {
  const { classes: i } = k();
  return /* @__PURE__ */ s.jsx("div", { className: i.root, children: o });
}
const z = m()(({ mode: o, spacing: i, typography: r }) => f.ifFeature(
  "encore",
  {
    root: {
      color: o === n.Dye ? t.main : void 0,
      fontSize: r.small.fontSize,
      fontWeight: r.fontWeightSemibold,
      lineHeight: r.small.lineHeight,
      overflowWrap: "anywhere",
      padding: `${i(1)} ${i(1.5)}`
    }
  },
  {
    root: {
      color: o === n.Dye ? t.main : void 0,
      fontSize: r.teenie.fontSize,
      lineHeight: r.teenie.lineHeight,
      padding: "9px 10px"
    }
  }
));
function j({ children: o }) {
  const { classes: i } = z();
  return /* @__PURE__ */ s.jsx("div", { className: i.root, children: o });
}
const H = m()(({ mode: o, palette: i, spacing: r }) => f.ifFeature(
  "encore",
  {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: r(0.5),
      outline: o === n.Dye ? `1px solid ${t.main}` : void 0,
      width: "200px"
    }
  },
  {
    root: {
      background: "none",
      borderRight: `1px solid ${i.primary.lightest}`,
      outline: o === n.Dye ? `1px solid ${t.main}` : void 0,
      padding: "16px 20px",
      width: "225px"
    }
  }
));
function u({ ariaLabel: o, items: i }) {
  const { classes: r } = H();
  return /* @__PURE__ */ s.jsx("nav", { "aria-label": o, className: r.root, "data-fabric-component": "SideSubNavigation", children: i });
}
u.Divider = h;
u.Link = v;
u.Title = $;
u.GroupTitle = j;
export {
  u as S
};
//# sourceMappingURL=side-sub-navigation-BXipEKtZ.mjs.map
